// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/diverse-people-working-office.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .onboarding-page {
  background: url("https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1600&q=80")
    no-repeat center center/cover;
  min-height: 100vh;
  color: white;
    font-family: "IBM Plex Sans", sans-serif;
  display: flex;
  justify-content: center;
  padding: 2rem;
}

.onboarding-overlay {
  background-color: rgba(0, 0, 0, 0.75);
  padding: 2rem;
  border-radius: 16px;
  max-width: 1100px;
  width: 100%;
  animation: fadeIn 1.2s ease;
}

.animated-heading {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
}

.tagline {
  text-align: center;
  font-size: 1.2rem;
  color: #ccc;
  margin-bottom: 2rem;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.card {
  background: rgba(255, 255, 255, 0.1);
  padding: 1.25rem;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
}

.card:hover {
  transform: translateY(-6px);
  background: rgba(255, 255, 255, 0.15);
  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.4);
}

.card-content {
  margin-top: 1rem;
  font-size: 0.95rem;
  line-height: 1.5;
  color: #eaeaea;
}

button {
  margin-top: 1.5rem;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s ease;
}

button:hover {
  background-color: #0056b3;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
} */

.role-selection-page {
  background: linear-gradient(#00000080, #00000080),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center
      center/cover;
  min-height: 100vh;
  padding: 40px 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.title {
  font-size: 2.5rem;
  margin-bottom: 30px;
  font-family: "IBM Plex Sans", sans-serif;
  color: #ffffff;
}

.role-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  justify-content: center;
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
}

.role-card {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 30px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.role-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
}

.icon {
  font-size: 2.8rem;
  color: #ffffff;
  margin-bottom: 15px;
}

.label {
  font-size: 1.1rem;
  font-weight: 600;
  font-family: "IBM Plex Sans", sans-serif;
  color: #ffffff;
}

/* Back Button */
.back-button-container {
  margin-top: 40px;
  text-align: center;
}

.back-button {
  padding: 12px 24px;
  font-size: 1rem;
  font-weight: 600;
  background-color: rgba(255, 255, 255, 0.15);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  cursor: pointer;
  backdrop-filter: blur(8px);
  transition: all 0.3s ease;
}

.back-button:hover {
  background-color: rgba(255, 255, 255, 0.25);
  transform: scale(1.05);
}

/* Modal Styling */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  padding: 20px;
}

.modal {
  background: rgba(255, 255, 255, 0.1);
  padding: 30px 20px;
  border-radius: 12px;
  backdrop-filter: blur(12px);
  text-align: center;
  width: 100%;
  max-width: 400px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
}

.modal h2 {
  font-size: 1.2rem;
  margin-bottom: 15px;
}

.modal input {
  padding: 10px;
  width: 100%;
  margin-top: 15px;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
}

.modal-actions {
  margin-top: 20px;
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.modal-actions button {
  font-size: 1rem;
  padding: 10px 16px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 6px;
  border: none;
  transition: all 0.3s ease;
  min-width: 140px;
}

.modal-actions .cancel {
  background-color: #ff5555;
  color: white;
}

.modal-actions button:not(.cancel) {
  background-color: #2b7de9;
  color: white;
}

.error {
  color: #ffaaaa;
  margin-top: 10px;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .title {
    font-size: 1.75rem;
  }

  .role-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .role-card {
    padding: 20px;
  }

  .modal {
    padding: 24px 16px;
    max-width: 100%;
  }

  .modal h2 {
    font-size: 1rem;
  }

  .modal input {
    font-size: 0.95rem;
  }

  .modal-actions {
    flex-direction: column;
    gap: 12px;
  }

  .modal-actions button {
    font-size: 0.9rem;
    padding: 10px;
    width: 100%;
    min-width: auto;
  }
}

@media (max-width: 480px) {
  .modal {
    padding: 20px 16px;
  }

  .modal h2 {
    font-size: 1rem;
  }

  .modal input {
    font-size: 0.95rem;
  }

  .modal-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .modal-actions button {
    font-size: 0.9rem;
    padding: 10px;
    width: 100%;
    min-width: unset;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Onboarding.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAuFG;;AAEH;EACE;;kBAEgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,yCAAyC;EACzC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;EACxC,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,gBAAgB;EAClB;AACF","sourcesContent":["/* .onboarding-page {\n  background: url(\"https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1600&q=80\")\n    no-repeat center center/cover;\n  min-height: 100vh;\n  color: white;\n    font-family: \"IBM Plex Sans\", sans-serif;\n  display: flex;\n  justify-content: center;\n  padding: 2rem;\n}\n\n.onboarding-overlay {\n  background-color: rgba(0, 0, 0, 0.75);\n  padding: 2rem;\n  border-radius: 16px;\n  max-width: 1100px;\n  width: 100%;\n  animation: fadeIn 1.2s ease;\n}\n\n.animated-heading {\n  text-align: center;\n  font-size: 2.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.tagline {\n  text-align: center;\n  font-size: 1.2rem;\n  color: #ccc;\n  margin-bottom: 2rem;\n}\n\n.card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.card {\n  background: rgba(255, 255, 255, 0.1);\n  padding: 1.25rem;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n}\n\n.card:hover {\n  transform: translateY(-6px);\n  background: rgba(255, 255, 255, 0.15);\n  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.4);\n}\n\n.card-content {\n  margin-top: 1rem;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  color: #eaeaea;\n}\n\nbutton {\n  margin-top: 1.5rem;\n  padding: 0.75rem 1.5rem;\n  font-size: 1rem;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\nbutton:hover {\n  background-color: #0056b3;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n} */\n\n.role-selection-page {\n  background: linear-gradient(#00000080, #00000080),\n    url(\"/public/diverse-people-working-office.jpg\") no-repeat center\n      center/cover;\n  min-height: 100vh;\n  padding: 40px 20px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.title {\n  font-size: 2.5rem;\n  margin-bottom: 30px;\n  font-family: \"IBM Plex Sans\", sans-serif;\n  color: #ffffff;\n}\n\n.role-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 20px;\n  justify-content: center;\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.role-card {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 30px 20px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n  text-align: center;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.role-card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);\n}\n\n.icon {\n  font-size: 2.8rem;\n  color: #ffffff;\n  margin-bottom: 15px;\n}\n\n.label {\n  font-size: 1.1rem;\n  font-weight: 600;\n  font-family: \"IBM Plex Sans\", sans-serif;\n  color: #ffffff;\n}\n\n/* Back Button */\n.back-button-container {\n  margin-top: 40px;\n  text-align: center;\n}\n\n.back-button {\n  padding: 12px 24px;\n  font-size: 1rem;\n  font-weight: 600;\n  background-color: rgba(255, 255, 255, 0.15);\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 8px;\n  cursor: pointer;\n  backdrop-filter: blur(8px);\n  transition: all 0.3s ease;\n}\n\n.back-button:hover {\n  background-color: rgba(255, 255, 255, 0.25);\n  transform: scale(1.05);\n}\n\n/* Modal Styling */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n  padding: 20px;\n}\n\n.modal {\n  background: rgba(255, 255, 255, 0.1);\n  padding: 30px 20px;\n  border-radius: 12px;\n  backdrop-filter: blur(12px);\n  text-align: center;\n  width: 100%;\n  max-width: 400px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: white;\n}\n\n.modal h2 {\n  font-size: 1.2rem;\n  margin-bottom: 15px;\n}\n\n.modal input {\n  padding: 10px;\n  width: 100%;\n  margin-top: 15px;\n  border: none;\n  border-radius: 6px;\n  font-size: 1rem;\n}\n\n.modal-actions {\n  margin-top: 20px;\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.modal-actions button {\n  font-size: 1rem;\n  padding: 10px 16px;\n  font-weight: bold;\n  cursor: pointer;\n  border-radius: 6px;\n  border: none;\n  transition: all 0.3s ease;\n  min-width: 140px;\n}\n\n.modal-actions .cancel {\n  background-color: #ff5555;\n  color: white;\n}\n\n.modal-actions button:not(.cancel) {\n  background-color: #2b7de9;\n  color: white;\n}\n\n.error {\n  color: #ffaaaa;\n  margin-top: 10px;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .title {\n    font-size: 1.75rem;\n  }\n\n  .role-grid {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n\n  .role-card {\n    padding: 20px;\n  }\n\n  .modal {\n    padding: 24px 16px;\n    max-width: 100%;\n  }\n\n  .modal h2 {\n    font-size: 1rem;\n  }\n\n  .modal input {\n    font-size: 0.95rem;\n  }\n\n  .modal-actions {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .modal-actions button {\n    font-size: 0.9rem;\n    padding: 10px;\n    width: 100%;\n    min-width: auto;\n  }\n}\n\n@media (max-width: 480px) {\n  .modal {\n    padding: 20px 16px;\n  }\n\n  .modal h2 {\n    font-size: 1rem;\n  }\n\n  .modal input {\n    font-size: 0.95rem;\n  }\n\n  .modal-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .modal-actions button {\n    font-size: 0.9rem;\n    padding: 10px;\n    width: 100%;\n    min-width: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
